import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiV1, apiV2 } from "../Auth/Interceptor";

const initialStateValue = {
  activeModal: null,
  modalDisplay: false,
  modalImage: null,
  orderDetails: {
    orderDetails: {},
    loading: "idle",
    error: null,
  },
  returnOrderDetails: {
    orderDetails: {},
    loading: "idle",
    error: null,
  },
  orderStatus: null,
  shipmentData: {
    shipmentData: {},
    loading: "idle",
    error: null,
  },
  scans: [],
  lastStatus: {},
};

const fetchOrderDetails = createAsyncThunk(
  "orders/fetchOrderDetails",
  async (orderId) => {
    try {
      const response = await apiV1.get(`ordermanage/getSingle?id=${orderId}`);
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
);

const fetchShipmentData = createAsyncThunk(
  "orders/fetchShipmentData",
  async (orderId) => {
    try {
      const response = await apiV1.get(`track/track?id=${orderId}`);
      if (response.data === "") {
        return {};
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

const fetchReturnOrderDetails = createAsyncThunk(
  "orders/fetchReturnOrderDetails",
  async (orderId) => {
    try {
      const response = await apiV2.get(`seller/orderReturn/${orderId}`);
      return response.data?.data[0];
    } catch (error) {
      throw error;
    }
  }
);

const orderDetailsSlice = createSlice({
  name: "orderDetails",
  initialState: initialStateValue,
  reducers: {
    setModal: (state, action) => {
      state.activeModal = action.payload;
      state.modalDisplay = true;
    },
    closeModal: (state, _) => {
      state.activeModal = null;
      state.modalDisplay = false;
      state.modalImage = null;
    },
    setImage: (state, action) => {
      state.modalImage = action.payload;
    },
    setOrderStatus: (state, action) => {
      state.orderStatus = action.payload;
    },
    setScans: (state, action) => {
      state.scans = action.payload;
    },
    setLastStatus: (state, action) => {
      state.lastStatus = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderDetails.pending, (state) => {
        state.orderDetails.loading = "loading";
      })
      .addCase(fetchOrderDetails.fulfilled, (state, action) => {
        state.orderDetails.loading = "succeeded";
        state.orderDetails.orderDetails = action.payload;
        state.orderDetails.error = null;
      })
      .addCase(fetchOrderDetails.rejected, (state, action) => {
        state.orderDetails.loading = "failed";
        state.orderDetails.error = action.error.message;
      })

      .addCase(fetchShipmentData.pending, (state) => {
        state.shipmentData.loading = "loading";
      })
      .addCase(fetchShipmentData.fulfilled, (state, action) => {
        state.shipmentData.loading = "succeeded";
        state.shipmentData.shipmentData = action.payload;
        state.shipmentData.error = null;
      })
      .addCase(fetchShipmentData.rejected, (state, action) => {
        state.shipmentData.loading = "failed";
        state.shipmentData.error = action.error.message;
      })
      
      .addCase(fetchReturnOrderDetails.pending, (state) => {
        state.returnOrderDetails.loading = "loading";
      })
      .addCase(fetchReturnOrderDetails.fulfilled, (state, action) => {
        state.returnOrderDetails.loading = "succeeded";
        state.returnOrderDetails.orderDetails = action.payload;
        state.returnOrderDetails.error = null;
      })
      .addCase(fetchReturnOrderDetails.rejected, (state, action) => {
        state.returnOrderDetails.loading = "failed";
        state.returnOrderDetails.error = action.error.message;
      });
  },
});

export const {
  setModal,
  closeModal,
  setImage,
  setOrderStatus,
  setScans,
  setLastStatus,
} = orderDetailsSlice.actions;

export { fetchOrderDetails, fetchShipmentData, fetchReturnOrderDetails };

export default orderDetailsSlice.reducer;